import { render, staticRenderFns } from "./addhouse.vue?vue&type=template&id=382feba8&scoped=true&"
import script from "./addhouse.vue?vue&type=script&lang=js&"
export * from "./addhouse.vue?vue&type=script&lang=js&"
import style0 from "./addhouse.vue?vue&type=style&index=0&lang=less&"
import style1 from "./addhouse.vue?vue&type=style&index=1&id=382feba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382feba8",
  null
  
)

export default component.exports